import {
  SET_TOKEN_VALIDATION_STATE,
  FILL_AUTH_SERVICE_POINT_DATA,
  TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA,
  SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA,
  SET_AFTER_AUTHORIZATION_URL,
  SET_FORM_TYPE,
} from './mutations-types';

export default {
  [FILL_AUTH_SERVICE_POINT_DATA](state, payload) {
    const _state = state;
    _state.params = payload.params;
    _state.platform_url = payload.platform_url;
    _state.type = payload.type;
    _state.gateway = payload.gateway;
  },

  [SET_TOKEN_VALIDATION_STATE](state, payload) {
    const _state = state;
    _state.tokenIsValid = payload.isValid;
  },

  [TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA](state) {
    const _state = state;
    _state.isWaitingForAuthServicePointData = !_state.isWaitingForAuthServicePointData;
  },

  [SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA](state, payload) {
    const _state = state;
    _state.isWaitingForAuthServicePointData = payload;
  },

  [SET_AFTER_AUTHORIZATION_URL](state, payload) {
    const _state = state;
    _state.afterAuthorizationUrl = payload.url;
  },

  [SET_FORM_TYPE](state, payload) {
    const _state = state;
    _state.type = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/authServicesPoints/mutations.js